export default class Base {
    constructor(items, props = {}, rootProps = {}) {
        if (typeof items === 'object') {
            items = Object.values(items);
        }

        items = Array.isArray(items) ? items || [] : [];

        this.rootProps = rootProps;
        this.data = this.handleProperties(items, props, rootProps);
    }

    handleProperties(items, props, rootProps) {
        items = items.map(item => {
            for (let propKey in props) {
                item[propKey] = props[propKey];
            }

            return item;
        });

        return items;
    }
}
